const tabSection = document.querySelector('.shopify-section--tabs');
const tabElement = document.querySelector('.tabElem__jsGetter');
const headerElem = document.querySelector('.shopify-section--header');
const referenceElem = tabSection.nextSibling;
const [layers, specification,firmOMeter, watchNShop, benefits, comparision, review, faq] = [
  document.getElementById('layers_main_wrapper_clss'),
  document.getElementById('benefits_clss_main_wrapper'),
  document.getElementById('firm_o_meter_main_wrapper'),
  document.getElementById('watch_and_shop_main_wrapper'),
  document.getElementById('benefits_main_wrapper'),
  document.getElementById('comparison_main_wrapper'),
  document.getElementById('judgeme_product_reviews'),
  document.getElementById('faq_main_wrapper')
]
const element = [layers, specification,firmOMeter, watchNShop, benefits, comparision, review, faq];
const links = document.querySelectorAll('.tab.custom-new-clss-cr');
const link = Array.from(links)

document.addEventListener('DOMContentLoaded', ()=>{
  try{
    if(window.innerWidth > 600){
      document.addEventListener('scroll', ()=>{
        const tabCoordinate = tabElement.getBoundingClientRect();
          let topCoordinates = tabCoordinate.top;
        const referenceCoordinate = referenceElem.getBoundingClientRect().top;
        if(topCoordinates < 38){
          headerElem.classList.add('disp-header-none');
              tabElement.classList.add('positionTab--sticky');
            if(referenceCoordinate > 83) {
              headerElem.classList.remove('disp-header-none');
                tabElement.classList.remove('positionTab--sticky');
            }
        }
        element.forEach((cr, index)=>{
          if(cr.getBoundingClientRect().top < 450 || cr.getBoundingClientRect().top > (cr.getBoundingClientRect().top + cr.getBoundingClientRect().height)){
            link.forEach((li, indexNew)=>{
              if(index === indexNew){
                li.style.background = '#f3fbee';
              } else {
                li.style.background = 'unset';
              }
            })
          } else {
              link[index].style.background = 'unset';
          }
        })
      })
    } else{
      console.log(`window width is exceed from 600px`)
    }
  } catch(error){
    console.error(`AN Error: ${error}`)
  }
})


// start of script for product slider button
        let currentIndex = 0;
        const items = document.querySelectorAll(".product-gallery__media");

        const totalItems = items.length;

        function updateSlide(newIndex) {          
          console.log(newIndex);
          
            items[currentIndex].classList.remove("active");
            items[currentIndex].classList.add(newIndex > currentIndex ? "previous" : "next");

            currentIndex = newIndex;

            items[currentIndex].classList.remove("previous", "next");
            items[currentIndex].classList.add("active");
        }

        function nextSlide() {
          console.log('nextSlide');
            let newIndex = (currentIndex + 1) % totalItems; // Loop to first item
          
            updateSlide(newIndex);
        }

        function prevSlide() {
            let newIndex = (currentIndex - 1 + totalItems) % totalItems; // Loop to last item
            updateSlide(newIndex);
        }
// end of script for product slider button   
